import { Route, Routes } from 'react-router-dom';
import MobileApp from './MobileApp';
import { MOBILE_APP_RESET_PASSWORD_LINK } from '../../assets/utils/constants';
import MobileAppResetPassword from './MobileAppResetPassword/MobileAppResetPassword';
 
function MobileAppRouter() {
  return (
    <Routes>
       <Route index element={<MobileApp />} />
       <Route path={`${MOBILE_APP_RESET_PASSWORD_LINK}`} element={<MobileAppResetPassword />} />
    </Routes>
  );
}
 
export default MobileAppRouter